(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.getActiveHeader();
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', () => {
        this.getActiveHeader();
        this.setHeaderHeight();
      });

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    getActiveHeader() {
      const isMobile = window.innerWidth <= 1024;
      this.header = isMobile 
        ? document.querySelector('#navbar-header-mobile')
        : document.querySelector('#navbar-header-desktop');
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const forceSolid = this.classList.contains('header-solid') || document.querySelector('.header-wrapper')?.classList.contains('header-solid');
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!this.header) return;

      // if (scrollTop === 0) {
      //   this.header.style.backgroundColor = 'transparent';
      //   this.header.style.borderBottom = 'none';
      //   this.header.style.backdropFilter = 'none';
      // } else {
      //   this.header.style.backgroundColor = '#231F2080';
      //   this.header.style.borderBottom = '1px solid #757575';
      //   this.header.style.webkitBackdropFilter = 'blur(120px)';
      //   this.header.style.backdropFilter = 'blur(120px)';
      // }

      if (scrollTop === 0 && !forceSolid) {
        this.header.style.backgroundColor = 'transparent';
        this.header.style.borderBottom = 'none';
        this.header.style.backdropFilter = 'none';
      } else {
        this.header.style.backgroundColor = '#231F2080';
        this.header.style.borderBottom = '1px solid #757575';
        this.header.style.webkitBackdropFilter = 'blur(120px)';
        this.header.style.backdropFilter = 'blur(120px)';
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Check if mobile navigation is open - if so, don't hide the header
      const mainNav = document.getElementById('main-nav-mobile');
      const isMobileNavOpen = mainNav && mainNav.classList.contains('open');

      if (isMobileNavOpen) {
        // Keep header visible when mobile nav is open
        this.header.classList.add('header-visible');
        this.header.classList.remove('header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('header-hidden');
        this.header.classList.remove('header-visible');
      } else if (scrollTop < this.currentScrollTop) {
        this.header.classList.add('header-visible');
        this.header.classList.remove('header-hidden');
      }

      this.currentScrollTop = scrollTop;
    }


  }

  customElements.define('sticky-header', StickyHeader);

  // The debounce function receives our function as a parameter
  const debounce = (fn) => {
    // This holds the requestAnimationFrame reference, so we can cancel it if we wish
    let frame;

    // The debounce function returns a new function that can receive a variable number of arguments
    return (...params) => {
      // If the frame variable has been defined, clear it now, and queue for next frame
      if (frame) {
        cancelAnimationFrame(frame);
      }

      // Queue our function call for the next frame
      frame = requestAnimationFrame(() => {
        // Call our function and pass any params we received
        fn(...params);
      });
    };
  };

  // Reads out the scroll position and stores it in the data attribute
  // so we can use it in our stylesheets
  const storeScroll = () => {
    document.documentElement.dataset.scroll = window.scrollY;
  };

  // Listen for new scroll events, here we debounce our `storeScroll` function
  document.addEventListener('scroll', debounce(storeScroll), { passive: true });

  // Update scroll position for first time
  storeScroll();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m10-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get elements with m10-specific selectors
    const mainImage = document.querySelector('.m10-main-product-image');
    const galleryImages = document.querySelectorAll('.m10-gallery-image');
    const galleryContainer = document.querySelector('.m10-product-gallery');
    const prevButton = document.getElementById('m10-imagePrev');
    const nextButton = document.getElementById('m10-imageNext');

    if (!mainImage || galleryImages.length === 0) {
      return;
    }

    // Image data array
    const images = Array.from(galleryImages).map((img) => ({
      src: img.getAttribute('data-full-image'),
      alt: img.getAttribute('data-alt'),
      index: parseInt(img.getAttribute('data-index')),
    }));

    let currentImageIndex = 0;
    let currentCarouselStart = 0;
    const visibleThumbnails = 3;
    const totalImages = images.length;

    // Zoom functionality variables
    let isZoomed = false;
    let isDragging = false;
    let hasDragged = false;
    let startX = 0;
    let startY = 0;
    let translateX = 0;
    let translateY = 0;
    let lastTouchTime = 0;

    function resetZoom() {
      if (mainImage) {
        mainImage.classList.remove('m10-zoomed');
        mainImage.style.transform = '';
        mainImage.style.cursor = 'zoom-in';
        isZoomed = false;
        translateX = 0;
        translateY = 0;
      }
    }

    function updateMainImage(index) {
      if (images[index]) {
        resetZoom();
        mainImage.src = images[index].src;
        mainImage.alt = images[index].alt;
        currentImageIndex = index;
        updateGalleryCarousel();
      }
    }

    function updateGalleryCarousel() {
      // Calculate which images should be visible in the carousel
      // If current image is in the visible range, don't move carousel
      if (currentImageIndex >= currentCarouselStart && currentImageIndex < currentCarouselStart + visibleThumbnails) {
        // Current image is visible, just update active state
      } else {
        // Current image is not visible, adjust carousel position
        if (currentImageIndex < currentCarouselStart) {
          currentCarouselStart = Math.max(0, currentImageIndex);
        } else {
          currentCarouselStart = Math.min(totalImages - visibleThumbnails, currentImageIndex - visibleThumbnails + 1);
        }
      }

      // Ensure carousel start is within bounds
      currentCarouselStart = Math.max(0, Math.min(totalImages - visibleThumbnails, currentCarouselStart));

      // Hide all gallery images
      galleryImages.forEach((img) => {
        img.style.display = 'none';
        img.classList.remove('m10-active');
      });

      // Show visible gallery images
      for (let i = 0; i < visibleThumbnails && currentCarouselStart + i < totalImages; i++) {
        const imageIndex = currentCarouselStart + i;
        const galleryImage = Array.from(galleryImages).find(
          (img) => parseInt(img.getAttribute('data-index')) === imageIndex
        );

        if (galleryImage) {
          galleryImage.style.display = 'block';
          if (imageIndex === currentImageIndex) {
            galleryImage.classList.add('m10-active');
          }
        }
      }
    }

    function nextImage() {
      const nextIndex = (currentImageIndex + 1) % totalImages;
      updateMainImage(nextIndex);
    }

    function prevImage() {
      const prevIndex = (currentImageIndex - 1 + totalImages) % totalImages;
      updateMainImage(prevIndex);
    }

    // Navigation arrow event listeners
    if (nextButton) {
      nextButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        nextImage();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prevImage();
      });
    }

    // Gallery thumbnail click functionality
    galleryImages.forEach(function (galleryImage) {
      galleryImage.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const imageIndex = parseInt(galleryImage.getAttribute('data-index'));

        if (!isNaN(imageIndex)) {
          updateMainImage(imageIndex);
        }
      });
    });

    // Zoom functionality - Click to zoom
    mainImage.addEventListener('click', function (e) {
      if (hasDragged) {
        hasDragged = false;
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (!isZoomed) {
        mainImage.classList.add('m10-zoomed');
        mainImage.style.cursor = 'grab';
        isZoomed = true;
      } else {
        resetZoom();
      }
    });

    // Mouse drag functionality when zoomed
    mainImage.addEventListener('mousedown', function (e) {
      if (!isZoomed) return;

      isDragging = true;
      hasDragged = false;
      startX = e.clientX - translateX;
      startY = e.clientY - translateY;
      mainImage.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging || !isZoomed) return;

      hasDragged = true;
      translateX = e.clientX - startX;
      translateY = e.clientY - startY;

      const maxTranslate = 150;
      translateX = Math.max(-maxTranslate, Math.min(maxTranslate, translateX));
      translateY = Math.max(-maxTranslate, Math.min(maxTranslate, translateY));

      mainImage.style.transform = `scale(2) translate(${translateX}px, ${translateY}px)`;
    });

    document.addEventListener('mouseup', function () {
      if (isDragging) {
        if (isZoomed) {
          mainImage.style.cursor = 'grab';
        }
        isDragging = false;

        setTimeout(function () {
          hasDragged = false;
        }, 100);
      }
    });

    // Touch events for mobile
    mainImage.addEventListener('touchstart', function (e) {
      if (!isZoomed) return;

      isDragging = true;
      hasDragged = false;
      const touch = e.touches[0];
      startX = touch.clientX - translateX;
      startY = touch.clientY - translateY;
      e.preventDefault();
    });

    document.addEventListener('touchmove', function (e) {
      if (!isDragging || !isZoomed) return;

      hasDragged = true;
      const touch = e.touches[0];
      translateX = touch.clientX - startX;
      translateY = touch.clientY - startY;

      const maxTranslate = 150;
      translateX = Math.max(-maxTranslate, Math.min(maxTranslate, translateX));
      translateY = Math.max(-maxTranslate, Math.min(maxTranslate, translateY));

      mainImage.style.transform = `scale(2) translate(${translateX}px, ${translateY}px)`;
      e.preventDefault();
    });

    document.addEventListener('touchend', function () {
      if (isDragging) {
        isDragging = false;

        setTimeout(function () {
          hasDragged = false;
        }, 100);
      }
    });

    // Double-tap to zoom on mobile
    mainImage.addEventListener('touchend', function (e) {
      const currentTime = new Date().getTime();
      const tapGap = currentTime - lastTouchTime;

      if (tapGap < 300 && tapGap > 0 && !hasDragged) {
        e.preventDefault();

        if (!isZoomed) {
          mainImage.classList.add('m10-zoomed');
          isZoomed = true;
        } else {
          resetZoom();
        }
      }

      lastTouchTime = currentTime;
    });

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isZoomed) {
        resetZoom();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      }
    });

    // Reset zoom on window resize
    window.addEventListener('resize', function () {
      if (isZoomed) {
        resetZoom();
      }
    });

    // Initialize the carousel
    updateGalleryCarousel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m6-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get elements with m6-specific selectors
    const mainImage = document.querySelector('.m6-main-product-image');
    const galleryImages = document.querySelectorAll('.m6-gallery-image');
    const galleryContainer = document.querySelector('.m6-product-gallery');
    const prevButton = document.getElementById('m6-imagePrev');
    const nextButton = document.getElementById('m6-imageNext');

    if (!mainImage || galleryImages.length === 0) {
      return;
    }

    // Image data array
    const images = Array.from(galleryImages).map((img) => ({
      src: img.getAttribute('data-full-image'),
      alt: img.getAttribute('data-alt'),
      index: parseInt(img.getAttribute('data-index')),
    }));

    let currentImageIndex = 0;
    let currentCarouselStart = 0;
    const visibleThumbnails = 3;
    const totalImages = images.length;

    // Zoom functionality variables
    let isZoomed = false;
    let isDragging = false;
    let hasDragged = false;
    let startX = 0;
    let startY = 0;
    let translateX = 0;
    let translateY = 0;
    let lastTouchTime = 0;

    function resetZoom() {
      if (mainImage) {
        mainImage.classList.remove('m6-zoomed');
        mainImage.style.transform = '';
        mainImage.style.cursor = 'zoom-in';
        isZoomed = false;
        translateX = 0;
        translateY = 0;
      }
    }

    function updateMainImage(index) {
      if (images[index]) {
        resetZoom();
        mainImage.src = images[index].src;
        mainImage.alt = images[index].alt;
        currentImageIndex = index;
        updateGalleryCarousel();
      }
    }

    function updateGalleryCarousel() {
      // Calculate which images should be visible in the carousel
      // If current image is in the visible range, don't move carousel
      if (currentImageIndex >= currentCarouselStart && currentImageIndex < currentCarouselStart + visibleThumbnails) {
        // Current image is visible, just update active state
      } else {
        // Current image is not visible, adjust carousel position
        if (currentImageIndex < currentCarouselStart) {
          currentCarouselStart = Math.max(0, currentImageIndex);
        } else {
          currentCarouselStart = Math.min(totalImages - visibleThumbnails, currentImageIndex - visibleThumbnails + 1);
        }
      }

      // Ensure carousel start is within bounds
      currentCarouselStart = Math.max(0, Math.min(totalImages - visibleThumbnails, currentCarouselStart));

      // Hide all gallery images
      galleryImages.forEach((img) => {
        img.style.display = 'none';
        img.classList.remove('m6-active');
      });

      // Show visible gallery images
      for (let i = 0; i < visibleThumbnails && currentCarouselStart + i < totalImages; i++) {
        const imageIndex = currentCarouselStart + i;
        const galleryImage = Array.from(galleryImages).find(
          (img) => parseInt(img.getAttribute('data-index')) === imageIndex
        );

        if (galleryImage) {
          galleryImage.style.display = 'block';
          if (imageIndex === currentImageIndex) {
            galleryImage.classList.add('m6-active');
          }
        }
      }
    }

    function nextImage() {
      const nextIndex = (currentImageIndex + 1) % totalImages;
      updateMainImage(nextIndex);
    }

    function prevImage() {
      const prevIndex = (currentImageIndex - 1 + totalImages) % totalImages;
      updateMainImage(prevIndex);
    }

    // Navigation arrow event listeners
    if (nextButton) {
      nextButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        nextImage();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prevImage();
      });
    }

    // Gallery thumbnail click functionality
    galleryImages.forEach(function (galleryImage) {
      galleryImage.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const imageIndex = parseInt(galleryImage.getAttribute('data-index'));

        if (!isNaN(imageIndex)) {
          updateMainImage(imageIndex);
        }
      });
    });

    // Zoom functionality - Click to zoom
    mainImage.addEventListener('click', function (e) {
      if (hasDragged) {
        hasDragged = false;
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (!isZoomed) {
        mainImage.classList.add('m6-zoomed');
        mainImage.style.cursor = 'grab';
        isZoomed = true;
      } else {
        resetZoom();
      }
    });

    // Mouse drag functionality when zoomed
    mainImage.addEventListener('mousedown', function (e) {
      if (!isZoomed) return;

      isDragging = true;
      hasDragged = false;
      startX = e.clientX - translateX;
      startY = e.clientY - translateY;
      mainImage.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging || !isZoomed) return;

      hasDragged = true;
      translateX = e.clientX - startX;
      translateY = e.clientY - startY;

      const maxTranslate = 150;
      translateX = Math.max(-maxTranslate, Math.min(maxTranslate, translateX));
      translateY = Math.max(-maxTranslate, Math.min(maxTranslate, translateY));

      mainImage.style.transform = `scale(2) translate(${translateX}px, ${translateY}px)`;
    });

    document.addEventListener('mouseup', function () {
      if (isDragging) {
        if (isZoomed) {
          mainImage.style.cursor = 'grab';
        }
        isDragging = false;

        setTimeout(function () {
          hasDragged = false;
        }, 100);
      }
    });

    // Touch events for mobile
    mainImage.addEventListener('touchstart', function (e) {
      if (!isZoomed) return;

      isDragging = true;
      hasDragged = false;
      const touch = e.touches[0];
      startX = touch.clientX - translateX;
      startY = touch.clientY - translateY;
      e.preventDefault();
    });

    document.addEventListener('touchmove', function (e) {
      if (!isDragging || !isZoomed) return;

      hasDragged = true;
      const touch = e.touches[0];
      translateX = touch.clientX - startX;
      translateY = touch.clientY - startY;

      const maxTranslate = 150;
      translateX = Math.max(-maxTranslate, Math.min(maxTranslate, translateX));
      translateY = Math.max(-maxTranslate, Math.min(maxTranslate, translateY));

      mainImage.style.transform = `scale(2) translate(${translateX}px, ${translateY}px)`;
      e.preventDefault();
    });

    document.addEventListener('touchend', function () {
      if (isDragging) {
        isDragging = false;

        setTimeout(function () {
          hasDragged = false;
        }, 100);
      }
    });

    // Double-tap to zoom on mobile
    mainImage.addEventListener('touchend', function (e) {
      const currentTime = new Date().getTime();
      const tapGap = currentTime - lastTouchTime;

      if (tapGap < 300 && tapGap > 0 && !hasDragged) {
        e.preventDefault();

        if (!isZoomed) {
          mainImage.classList.add('m6-zoomed');
          isZoomed = true;
        } else {
          resetZoom();
        }
      }

      lastTouchTime = currentTime;
    });

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isZoomed) {
        resetZoom();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      }
    });

    // Reset zoom on window resize
    window.addEventListener('resize', function () {
      if (isZoomed) {
        resetZoom();
      }
    });

    // Initialize the carousel
    updateGalleryCarousel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb6-product-detail"] && !Shopify.designMode) return;
  try {
    
  class ProductSection extends HTMLElement {
    constructor() {
      super();
      this.galleryItems = this.querySelectorAll('.gallery-image');
      this.mainImage = this.querySelector('#ProductImage-{{ section.id }}');
      this.initializeGallery();
    }

    initializeGallery() {
      this.galleryItems.forEach((item) => {
        item.addEventListener('click', () => {
          const fullImage = item.dataset.fullImage;
          this.mainImage.src = fullImage;
          this.mainImage.setAttribute('data-zoom-image', fullImage);
        });
      });
    }
  }

  customElements.define('MB6-product-section', ProductSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-1-product-detail"] && !Shopify.designMode) return;
  try {
    
  class ProductSection extends HTMLElement {
    constructor() {
      super();
      this.galleryItems = this.querySelectorAll('.gallery-image');
      this.mainImage = this.querySelector('#ProductImage-{{ section.id }}');
      this.initializeGallery();
    }

    initializeGallery() {
      this.galleryItems.forEach((item) => {
        item.addEventListener('click', () => {
          const fullImage = item.dataset.fullImage;
          this.mainImage.src = fullImage;
          this.mainImage.setAttribute('data-zoom-image', fullImage);
        });
      });
    }
  }

  customElements.define('me-1-product-section', ProductSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-6-product-detail"] && !Shopify.designMode) return;
  try {
    
  class ProductSection extends HTMLElement {
    constructor() {
      super();
      this.galleryItems = this.querySelectorAll('.gallery-image');
      this.mainImage = this.querySelector('#ProductImage-{{ section.id }}');
      this.initializeGallery();
    }

    initializeGallery() {
      this.galleryItems.forEach((item) => {
        item.addEventListener('click', () => {
          const fullImage = item.dataset.fullImage;
          this.mainImage.src = fullImage;
          this.mainImage.setAttribute('data-zoom-image', fullImage);
        });
      });
    }
  }

  customElements.define('ME6-product-section', ProductSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt1-product-detail"] && !Shopify.designMode) return;
  try {
    
  class ProductSection extends HTMLElement {
    constructor() {
      super();
      this.galleryItems = this.querySelectorAll('.gallery-image');
      this.mainImage = this.querySelector('#ProductImage-{{ section.id }}');
      this.initializeGallery();
    }

    initializeGallery() {
      this.galleryItems.forEach((item) => {
        item.addEventListener('click', () => {
          const fullImage = item.dataset.fullImage;
          this.mainImage.src = fullImage;
          this.mainImage.setAttribute('data-zoom-image', fullImage);
        });
      });
    }
  }

  customElements.define('MT1-product-section', ProductSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt2-product-detail"] && !Shopify.designMode) return;
  try {
    
  class ProductSection extends HTMLElement {
    constructor() {
      super();
      this.galleryItems = this.querySelectorAll('.gallery-image');
      this.mainImage = this.querySelector('#ProductImage-{{ section.id }}');
      this.initializeGallery();
    }

    initializeGallery() {
      this.galleryItems.forEach((item) => {
        item.addEventListener('click', () => {
          const fullImage = item.dataset.fullImage;
          this.mainImage.src = fullImage;
          this.mainImage.setAttribute('data-zoom-image', fullImage);
        });
      });
    }
  }

  customElements.define('MT2-product-section', ProductSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["u2-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get elements with u2-specific selectors
    const mainImage = document.querySelector('.u2-main-product-image');
    const galleryImages = document.querySelectorAll('.u2-gallery-image');
    const galleryContainer = document.querySelector('.u2-product-gallery');
    const prevButton = document.getElementById('u2-imagePrev');
    const nextButton = document.getElementById('u2-imageNext');

    if (!mainImage || galleryImages.length === 0) {
      return;
    }

    // Image data array
    const images = Array.from(galleryImages).map((img) => ({
      src: img.getAttribute('data-full-image'),
      alt: img.getAttribute('data-alt'),
      index: parseInt(img.getAttribute('data-index')),
    }));

    let currentImageIndex = 0;
    let currentCarouselStart = 0;
    const visibleThumbnails = 3;
    const totalImages = images.length;

    // Zoom functionality variables
    let isZoomed = false;
    let isDragging = false;
    let hasDragged = false;
    let startX = 0;
    let startY = 0;
    let translateX = 0;
    let translateY = 0;
    let lastTouchTime = 0;

    function resetZoom() {
      if (mainImage) {
        mainImage.classList.remove('u2-zoomed');
        mainImage.style.transform = '';
        mainImage.style.cursor = 'zoom-in';
        isZoomed = false;
        translateX = 0;
        translateY = 0;
      }
    }

    function updateMainImage(index) {
      if (images[index]) {
        resetZoom();
        mainImage.src = images[index].src;
        mainImage.alt = images[index].alt;
        currentImageIndex = index;
        updateGalleryCarousel();
      }
    }

    function updateGalleryCarousel() {
      // Calculate which images should be visible in the carousel
      // If current image is in the visible range, don't move carousel
      if (currentImageIndex >= currentCarouselStart && currentImageIndex < currentCarouselStart + visibleThumbnails) {
        // Current image is visible, just update active state
      } else {
        // Current image is not visible, adjust carousel position
        if (currentImageIndex < currentCarouselStart) {
          currentCarouselStart = Math.max(0, currentImageIndex);
        } else {
          currentCarouselStart = Math.min(totalImages - visibleThumbnails, currentImageIndex - visibleThumbnails + 1);
        }
      }

      // Ensure carousel start is within bounds
      currentCarouselStart = Math.max(0, Math.min(totalImages - visibleThumbnails, currentCarouselStart));

      // Hide all gallery images
      galleryImages.forEach((img) => {
        img.style.display = 'none';
        img.classList.remove('u2-active');
      });

      // Show visible gallery images
      for (let i = 0; i < visibleThumbnails && currentCarouselStart + i < totalImages; i++) {
        const imageIndex = currentCarouselStart + i;
        const galleryImage = Array.from(galleryImages).find(
          (img) => parseInt(img.getAttribute('data-index')) === imageIndex
        );

        if (galleryImage) {
          galleryImage.style.display = 'block';
          if (imageIndex === currentImageIndex) {
            galleryImage.classList.add('u2-active');
          }
        }
      }
    }

    function nextImage() {
      const nextIndex = (currentImageIndex + 1) % totalImages;
      updateMainImage(nextIndex);
    }

    function prevImage() {
      const prevIndex = (currentImageIndex - 1 + totalImages) % totalImages;
      updateMainImage(prevIndex);
    }

    // Navigation arrow event listeners
    if (nextButton) {
      nextButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        nextImage();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        prevImage();
      });
    }

    // Gallery thumbnail click functionality
    galleryImages.forEach(function (galleryImage) {
      galleryImage.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const imageIndex = parseInt(galleryImage.getAttribute('data-index'));

        if (!isNaN(imageIndex)) {
          updateMainImage(imageIndex);
        }
      });
    });

    // Zoom functionality - Click to zoom
    mainImage.addEventListener('click', function (e) {
      if (hasDragged) {
        hasDragged = false;
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (!isZoomed) {
        mainImage.classList.add('u2-zoomed');
        mainImage.style.cursor = 'grab';
        isZoomed = true;
      } else {
        resetZoom();
      }
    });

    // Mouse drag functionality when zoomed
    mainImage.addEventListener('mousedown', function (e) {
      if (!isZoomed) return;

      isDragging = true;
      hasDragged = false;
      startX = e.clientX - translateX;
      startY = e.clientY - translateY;
      mainImage.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging || !isZoomed) return;

      hasDragged = true;
      translateX = e.clientX - startX;
      translateY = e.clientY - startY;

      const maxTranslate = 150;
      translateX = Math.max(-maxTranslate, Math.min(maxTranslate, translateX));
      translateY = Math.max(-maxTranslate, Math.min(maxTranslate, translateY));

      mainImage.style.transform = `scale(2) translate(${translateX}px, ${translateY}px)`;
    });

    document.addEventListener('mouseup', function () {
      if (isDragging) {
        if (isZoomed) {
          mainImage.style.cursor = 'grab';
        }
        isDragging = false;

        setTimeout(function () {
          hasDragged = false;
        }, 100);
      }
    });

    // Touch events for mobile
    mainImage.addEventListener('touchstart', function (e) {
      if (!isZoomed) return;

      isDragging = true;
      hasDragged = false;
      const touch = e.touches[0];
      startX = touch.clientX - translateX;
      startY = touch.clientY - translateY;
      e.preventDefault();
    });

    document.addEventListener('touchmove', function (e) {
      if (!isDragging || !isZoomed) return;

      hasDragged = true;
      const touch = e.touches[0];
      translateX = touch.clientX - startX;
      translateY = touch.clientY - startY;

      const maxTranslate = 150;
      translateX = Math.max(-maxTranslate, Math.min(maxTranslate, translateX));
      translateY = Math.max(-maxTranslate, Math.min(maxTranslate, translateY));

      mainImage.style.transform = `scale(2) translate(${translateX}px, ${translateY}px)`;
      e.preventDefault();
    });

    document.addEventListener('touchend', function () {
      if (isDragging) {
        isDragging = false;

        setTimeout(function () {
          hasDragged = false;
        }, 100);
      }
    });

    // Double-tap to zoom on mobile
    mainImage.addEventListener('touchend', function (e) {
      const currentTime = new Date().getTime();
      const tapGap = currentTime - lastTouchTime;

      if (tapGap < 300 && tapGap > 0 && !hasDragged) {
        e.preventDefault();

        if (!isZoomed) {
          mainImage.classList.add('u2-zoomed');
          isZoomed = true;
        } else {
          resetZoom();
        }
      }

      lastTouchTime = currentTime;
    });

    // Keyboard navigation
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isZoomed) {
        resetZoom();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      }
    });

    // Reset zoom on window resize
    window.addEventListener('resize', function () {
      if (isZoomed) {
        resetZoom();
      }
    });

    // Initialize the carousel
    updateGalleryCarousel();
  });

  } catch(e) { console.error(e); }
})();
})();
